var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBenefitsFilteredwater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 15.28,4.74 c -0.10395,-0.097787 -0.26605,-0.097787 -0.37,0 -0.3,0.34 -7.33,8.35 -7.33,12.41 0.2872018,3.930054 3.559467,7.108585 7.5,7.108585 3.940533,0 7.212798,-3.178531 7.5,-7.108585 0.03,-4.06 -7,-12.07 -7.3,-12.41 z M 15.1,23.749977 c -3.865993,0 -7,-2.723984 -7,-6.589977 0,-3.52 5.88,-10.54 7,-11.86 1.13,1.32 7,8.34 7,11.86 0,3.865993 -3.134007,6.589977 -7,6.589977 z",
    id: "path2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.17,16.83a.25.25,0,0,0-.25.25A4.84,4.84,0,0,1,15.1,21.9a.25.25,0,0,0,0,.5,5.33,5.33,0,0,0,5.32-5.32A.25.25,0,0,0,20.17,16.83Z",
    id: "path4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBenefitsFilteredwater);
export default __webpack_public_path__ + "static/media/icon_benefits_filteredwater.0e023579.svg";
export { ForwardRef as ReactComponent };